<div class="topology-layout">
  <div class="topology-side-panel">
    <div class="cake-groups-section">
      <div class="cake-groups-header">
        <div class="cake-groups-title">Groups</div>
        <button type="button" class="cake-add-button" (click)="addCakeGroup()" [disabled]="cakeGroups.length >= maxCakeGroups">Add group</button>
      </div>

      <div class="cake-group-list">
        <div class="cake-group-item" *ngFor="let group of cakeGroups; trackBy: trackCakeGroup" [class.selected-group]="group.id === selectedCakeGroupId" (click)="selectCakeGroup(group.id)">
          <div class="cake-group-field">
            <span class="cake-group-swatch" [style.backgroundColor]="getGroupColorForGroup(group.id)"></span>
            <input type="text" class="cake-group-input" [(ngModel)]="group.name" [attr.maxlength]="maxGroupNameLength" (blur)="normalizeCakeGroupName(group)" (click)="$event.stopPropagation()" />
          </div>

          <button type="button" class="cake-remove-button" (click)="$event.stopPropagation(); removeCakeGroup(group.id)" [disabled]="cakeGroups.length <= 1">Delete</button>
        </div>
      </div>
    </div>
  </div>

  <div class="topology-card" [style.--group-color]="getSelectedGroupColor()">
    <div class="topology-main-panel">
      <div class="topology-main-header">
        <span class="topology-main-title">Topology</span>
        <span class="topology-main-group">{{ getSelectedCakeGroupName() }}</span>
      </div>
      <svg class="topology-svg" viewBox="0 0 560 560" xmlns="http://www.w3.org/2000/svg" aria-label="EFATE topology">
    <defs>
      <marker id="arrow-solid" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto" markerUnits="strokeWidth">
        <path d="M0,0 L8,4 L0,8 Z" fill="#8a9099"></path>
      </marker>
      <marker id="arrow-solid-active" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto" markerUnits="strokeWidth">
        <path d="M0,0 L8,4 L0,8 Z" fill="#111827"></path>
      </marker>
      <marker id="arrow-dashed" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto-start-reverse" markerUnits="strokeWidth">
        <path d="M0,0 L8,4 L0,8 Z" fill="#8a9099"></path>
      </marker>
      <marker id="arrow-dashed-active" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto-start-reverse" markerUnits="strokeWidth">
        <path d="M0,0 L8,4 L0,8 Z" fill="#111827"></path>
      </marker>
    </defs>

    <g class="edges">
      <line x1="218" y1="108" x2="118" y2="168" class="solid-edge-line" [class.active-edge]="isEdgeActive('parent-a1')" [attr.marker-end]="getEdgeMarker('parent-a1', 'solid')"></line>
      <line x1="218" y1="108" x2="118" y2="168" class="edge-hitbox" (click)="toggleSingleDirectionEdge('parent-a1')"></line>

      <line x1="250" y1="120" x2="250" y2="150" class="solid-edge-line" [class.active-edge]="isEdgeActive('parent-b1')" [attr.marker-end]="getEdgeMarker('parent-b1', 'solid')"></line>
      <line x1="250" y1="120" x2="250" y2="150" class="edge-hitbox" (click)="toggleSingleDirectionEdge('parent-b1')"></line>

      <line x1="282" y1="108" x2="382" y2="168" class="solid-edge-line" [class.active-edge]="isEdgeActive('parent-c1')" [attr.marker-end]="getEdgeMarker('parent-c1', 'solid')"></line>
      <line x1="282" y1="108" x2="382" y2="168" class="edge-hitbox" (click)="toggleSingleDirectionEdge('parent-c1')"></line>
    </g>

    <g class="edges bidirectional-edge">
      <line x1="126" y1="196" x2="204" y2="196" class="dashed-edge-line" [class.active-edge]="isBidirectionalEdgeActive('a1-b1')" [class.disabled-edge]="!isBidirectionalEdgeEnabled('a1-b1') && !isBidirectionalEdgeActive('a1-b1')" [attr.marker-start]="getBidirectionalMarkerStart('a1-b1')" [attr.marker-end]="getBidirectionalMarkerEnd('a1-b1')"></line>
      <line x1="126" y1="196" x2="204" y2="196" class="edge-hitbox" [class.edge-hitbox-disabled]="!isBidirectionalEdgeEnabled('a1-b1') && !isBidirectionalEdgeActive('a1-b1')" (click)="toggleBidirectionalEdge('a1-b1')"></line>

      <line x1="296" y1="196" x2="374" y2="196" class="dashed-edge-line" [class.active-edge]="isBidirectionalEdgeActive('b1-c1')" [class.disabled-edge]="!isBidirectionalEdgeEnabled('b1-c1') && !isBidirectionalEdgeActive('b1-c1')" [attr.marker-start]="getBidirectionalMarkerStart('b1-c1')" [attr.marker-end]="getBidirectionalMarkerEnd('b1-c1')"></line>
      <line x1="296" y1="196" x2="374" y2="196" class="edge-hitbox" [class.edge-hitbox-disabled]="!isBidirectionalEdgeEnabled('b1-c1') && !isBidirectionalEdgeActive('b1-c1')" (click)="toggleBidirectionalEdge('b1-c1')"></line>

      <line x1="126" y1="330" x2="204" y2="330" class="dashed-edge-line" [class.active-edge]="isBidirectionalEdgeActive('a2-b2')" [class.disabled-edge]="!isBidirectionalEdgeEnabled('a2-b2') && !isBidirectionalEdgeActive('a2-b2')" [attr.marker-start]="getBidirectionalMarkerStart('a2-b2')" [attr.marker-end]="getBidirectionalMarkerEnd('a2-b2')"></line>
      <line x1="126" y1="330" x2="204" y2="330" class="edge-hitbox" [class.edge-hitbox-disabled]="!isBidirectionalEdgeEnabled('a2-b2') && !isBidirectionalEdgeActive('a2-b2')" (click)="toggleBidirectionalEdge('a2-b2')"></line>
    </g>

    <g class="edges">
      <line x1="80" y1="248" x2="80" y2="282" class="dashed-edge-line" [class.active-edge]="isEdgeActive('a1-a2')" [class.disabled-edge]="!isEdgeEnabled('a1-a2') && !isEdgeActive('a1-a2')" [attr.marker-end]="getEdgeMarker('a1-a2', 'dashed')"></line>
      <line x1="80" y1="248" x2="80" y2="282" class="edge-hitbox" [class.edge-hitbox-disabled]="!isEdgeEnabled('a1-a2') && !isEdgeActive('a1-a2')" (click)="toggleSingleDirectionEdge('a1-a2')"></line>

      <line x1="80" y1="378" x2="80" y2="412" class="dashed-edge-line" [class.active-edge]="isEdgeActive('a2-a3')" [class.disabled-edge]="!isEdgeEnabled('a2-a3') && !isEdgeActive('a2-a3')" [attr.marker-end]="getEdgeMarker('a2-a3', 'dashed')"></line>
      <line x1="80" y1="378" x2="80" y2="412" class="edge-hitbox" [class.edge-hitbox-disabled]="!isEdgeEnabled('a2-a3') && !isEdgeActive('a2-a3')" (click)="toggleSingleDirectionEdge('a2-a3')"></line>

      <line x1="250" y1="248" x2="250" y2="282" class="dashed-edge-line" [class.active-edge]="isEdgeActive('b1-b2')" [class.disabled-edge]="!isEdgeEnabled('b1-b2') && !isEdgeActive('b1-b2')" [attr.marker-end]="getEdgeMarker('b1-b2', 'dashed')"></line>
      <line x1="250" y1="248" x2="250" y2="282" class="edge-hitbox" [class.edge-hitbox-disabled]="!isEdgeEnabled('b1-b2') && !isEdgeActive('b1-b2')" (click)="toggleSingleDirectionEdge('b1-b2')"></line>

      <line x1="216" y1="242" x2="128" y2="302" class="dashed-edge-line" [class.active-edge]="isEdgeActive('b1-a2')" [class.disabled-edge]="!isEdgeEnabled('b1-a2') && !isEdgeActive('b1-a2')" [attr.marker-end]="getEdgeMarker('b1-a2', 'dashed')"></line>
      <line x1="216" y1="242" x2="128" y2="302" class="edge-hitbox" [class.edge-hitbox-disabled]="!isEdgeEnabled('b1-a2') && !isEdgeActive('b1-a2')" (click)="toggleSingleDirectionEdge('b1-a2')"></line>
    </g>

    <g class="edges status-edge" marker-end="url(#arrow-solid)">
      <line x1="58" y1="164" x2="34" y2="127"></line>
      <line x1="286" y1="80" x2="322" y2="80"></line>
      <line x1="281" y1="232" x2="313" y2="260"></line>
      <line x1="451" y1="232" x2="483" y2="260"></line>
      <line x1="111" y1="362" x2="143" y2="390"></line>
      <line x1="281" y1="362" x2="313" y2="390"></line>
      <line x1="111" y1="492" x2="143" y2="520"></line>
    </g>

    <g class="nodes">
      <circle cx="250" cy="80" r="35" class="node node-parent"></circle>
      <text x="250" y="87" text-anchor="middle" class="node-label node-label-parent">{{ getNodeDisplayName('Parent') }}</text>

      <circle cx="80" cy="200" r="34" [attr.class]="'node ' + getNodeClass('A1')"></circle>
      <text x="80" y="207" text-anchor="middle" class="node-label">{{ getNodeDisplayName('A1') }}</text>

      <circle cx="250" cy="200" r="34" [attr.class]="'node ' + getNodeClass('B1')"></circle>
      <text x="250" y="207" text-anchor="middle" class="node-label">{{ getNodeDisplayName('B1') }}</text>

      <circle cx="420" cy="200" r="34" [attr.class]="'node ' + getNodeClass('C1')"></circle>
      <text x="420" y="207" text-anchor="middle" class="node-label">{{ getNodeDisplayName('C1') }}</text>

      <circle cx="80" cy="330" r="34" [attr.class]="'node ' + getNodeClass('A2')"></circle>
      <text x="80" y="337" text-anchor="middle" class="node-label">{{ getNodeDisplayName('A2') }}</text>

      <circle cx="250" cy="330" r="34" [attr.class]="'node ' + getNodeClass('B2')"></circle>
      <text x="250" y="337" text-anchor="middle" class="node-label">{{ getNodeDisplayName('B2') }}</text>

      <circle cx="80" cy="460" r="34" [attr.class]="'node ' + getNodeClass('A3')"></circle>
      <text x="80" y="467" text-anchor="middle" class="node-label">{{ getNodeDisplayName('A3') }}</text>
    </g>

    <g class="node-status">
      <circle cx="22" cy="108" r="20" [attr.class]="getStatusNodeClass('status-a1')" [class.status-node-enabled]="isStatusNodeEnabled('status-a1')" (click)="toggleStatusNode('status-a1')"></circle>
      <circle cx="345" cy="80" r="20" [attr.class]="getStatusNodeClass('status-parent')" [class.status-node-enabled]="isStatusNodeEnabled('status-parent')" (click)="toggleStatusNode('status-parent')"></circle>
      <circle cx="330" cy="275" r="20" [attr.class]="getStatusNodeClass('status-b1')" [class.status-node-enabled]="isStatusNodeEnabled('status-b1')" (click)="toggleStatusNode('status-b1')"></circle>
      <circle cx="500" cy="275" r="20" [attr.class]="getStatusNodeClass('status-c1')" [class.status-node-enabled]="isStatusNodeEnabled('status-c1')" (click)="toggleStatusNode('status-c1')"></circle>
      <circle cx="160" cy="405" r="20" [attr.class]="getStatusNodeClass('status-a2')" [class.status-node-enabled]="isStatusNodeEnabled('status-a2')" (click)="toggleStatusNode('status-a2')"></circle>
      <circle cx="330" cy="405" r="20" [attr.class]="getStatusNodeClass('status-b2')" [class.status-node-enabled]="isStatusNodeEnabled('status-b2')" (click)="toggleStatusNode('status-b2')"></circle>
      <circle cx="160" cy="535" r="20" [attr.class]="getStatusNodeClass('status-a3')" [class.status-node-enabled]="isStatusNodeEnabled('status-a3')" (click)="toggleStatusNode('status-a3')"></circle>
    </g>
      </svg>
    </div>
  </div>

  <div class="topology-grid-card">
    <div class="topology-grid-title"></div>
    <table class="topology-grid" aria-label="Editable topology node names">
      <thead>
        <tr>
          <th>Key</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let nodeKey of topologyNodeKeys">
          <td class="grid-key">{{ nodeKey }}</td>
          <td>
            <input type="text" class="grid-input" [(ngModel)]="nodeNames[nodeKey]" [attr.aria-label]="'Name for ' + nodeKey" [attr.maxlength]="maxNodeNameLength" (blur)="normalizeNodeName(nodeKey)" (keydown.enter)="normalizeNodeName(nodeKey)" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
